var React = require('react');

function ExpandMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z","fill":"#fff"}));
}

ExpandMore.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExpandMore;

ExpandMore.default = ExpandMore;
